import DashboardLayout from "@/layout/dashboard/DashboardLayout.vue";
// GeneralViews
import NotFound from "@/pages/NotFoundPage.vue";

// Admin pages
import Dashboard from "@/pages/Dashboard.vue";
import UserProfile from "@/pages/UserProfile.vue";
import Njoftimet from "@/pages/Njoftimet.vue";
import Notat from "@/pages/Notat.vue";
import Libraria from "@/pages/Libraria.vue";
import Pagesat from "@/pages/Pagesat.vue";
import Planprogrami from "@/pages/Planprogrami.vue";
import OrariProvimeve from "@/pages/OrariProvimeve.vue";
// import ParaqitjaProvimeve from "@/pages/ParaqitjaProvimeve.vue"
import LibrariaKolegjit from "@/pages/LibrariaKolegjit.vue";
import LoginKolegji from "@/pages/LoginKolegji";

const routes = [
  {
    path: "/",
    name: "loginkolegji",
    component: LoginKolegji,
  },
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/dashboard",
    children: [
      {
        path: "/dashboard",
        name: "dashboard",
        component: Dashboard,
        meta: { requiresAuth: true },
      },
      {
        path: "/profili",
        name: "profili",
        component: UserProfile,
        meta: { requiresAuth: true },
      },
      {
        path: "/njoftimet",
        name: "njoftimet",
        component: Njoftimet,
        meta: { requiresAuth: true },
      },
      {
        path: "/notat",
        name: "notat",
        component: Notat,
        meta: { requiresAuth: true },
      },
      {
        path: "/libraria",
        name: "libraria",
        component: Libraria,
        meta: { requiresAuth: true },
      },
      {
        path: "/pagesat",
        name: "pagesat",
        component: Pagesat,
        meta: { requiresAuth: true },
      },
      {
        path: "/planprogrami",
        name: "planprogrami",
        component: Planprogrami,
        meta: { requiresAuth: true },
      },
      {
        path: "/orariprovimeve",
        name: "orariprovimeve",
        component: OrariProvimeve,
        meta: { requiresAuth: true },
      },
      // {
      //   path:"ParaqitjaProvimeve",
      //   name:"ParaqitjaProvimeve",
      //   component:ParaqitjaProvimeve

      // },
      {
        path: "/librariakolegjit",
        name: "librariakolegjit",
        component: LibrariaKolegjit,
        meta: { requiresAuth: true },
      },
      {
        path: "/loginkolegji",
        name: "loginkolegji",
        component: LoginKolegji,
      },
    ],
  },
  { path: "*", component: NotFound },
];

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes;
